module.exports = __webpack_public_path__ + "static/media/YM23_4.c0ac6e85.jpg";